// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActorDto } from './IClaimActorDto';
import {
    IClaimActorDtoFromJSON,
    IClaimActorDtoFromJSONTyped,
    IClaimActorDtoToJSON,
    IClaimActorDtoToJSONTyped,
} from './IClaimActorDto';
import type { IClaimAccountOrderDto } from './IClaimAccountOrderDto';
import {
    IClaimAccountOrderDtoFromJSON,
    IClaimAccountOrderDtoFromJSONTyped,
    IClaimAccountOrderDtoToJSON,
    IClaimAccountOrderDtoToJSONTyped,
} from './IClaimAccountOrderDto';

/**
 * 
 * @export
 * @interface ICreateClaimAggregatorDto
 */
export interface ICreateClaimAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    pay_to_type?: ICreateClaimAggregatorDtoPayToTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    payment_type?: ICreateClaimAggregatorDtoPaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    service_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    provider_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICreateClaimAggregatorDto
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICreateClaimAggregatorDto
     */
    local_date_service_on?: Date;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof ICreateClaimAggregatorDto
     */
    service_for?: IClaimActorDto;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof ICreateClaimAggregatorDto
     */
    assignee?: IClaimActorDto;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    source?: ICreateClaimAggregatorDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    employee_provider_acc?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    patient_provider_acc?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    provider_invoice?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    ocr_receipt_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    claim_status_type?: ICreateClaimAggregatorDtoClaimStatusTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {Array<IClaimAccountOrderDto>}
     * @memberof ICreateClaimAggregatorDto
     */
    account_orders?: Array<IClaimAccountOrderDto>;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateClaimAggregatorDto
     */
    receipt_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateClaimAggregatorDto
     */
    is_runout_overridden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICreateClaimAggregatorDto
     */
    employee_notes?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ICreateClaimAggregatorDto
     */
    lmn_ids?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum ICreateClaimAggregatorDtoPayToTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    CARD_PROCESSOR = 'CARD_PROCESSOR'
}
/**
* @export
* @enum {string}
*/
export enum ICreateClaimAggregatorDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum ICreateClaimAggregatorDtoSourceEnum {
    WEBSITE = 'WEBSITE',
    CLAIM_PROCESSOR = 'CLAIM_PROCESSOR',
    MOBILE_APP = 'MOBILE_APP',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    FILE = 'FILE',
    PAYMENT_CARD_TRX = 'PAYMENT_CARD_TRX'
}
/**
* @export
* @enum {string}
*/
export enum ICreateClaimAggregatorDtoClaimStatusTypeEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the ICreateClaimAggregatorDto interface.
 */
export function instanceOfICreateClaimAggregatorDto(value: object): value is ICreateClaimAggregatorDto {
    return true;
}

export function ICreateClaimAggregatorDtoFromJSON(json: any): ICreateClaimAggregatorDto {
    return ICreateClaimAggregatorDtoFromJSONTyped(json, false);
}

export function ICreateClaimAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateClaimAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'pay_to_type': json['pay_to_type'] == null ? undefined : json['pay_to_type'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
        'service_for': json['service_for'] == null ? undefined : IClaimActorDtoFromJSON(json['service_for']),
        'assignee': json['assignee'] == null ? undefined : IClaimActorDtoFromJSON(json['assignee']),
        'source': json['source'] == null ? undefined : json['source'],
        'employee_provider_acc': json['employee_provider_acc'] == null ? undefined : json['employee_provider_acc'],
        'patient_provider_acc': json['patient_provider_acc'] == null ? undefined : json['patient_provider_acc'],
        'provider_invoice': json['provider_invoice'] == null ? undefined : json['provider_invoice'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'ocr_receipt_id': json['ocr_receipt_id'] == null ? undefined : json['ocr_receipt_id'],
        'claim_status_type': json['claim_status_type'] == null ? undefined : json['claim_status_type'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'account_orders': json['account_orders'] == null ? undefined : ((json['account_orders'] as Array<any>).map(IClaimAccountOrderDtoFromJSON)),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'is_runout_overridden': json['is_runout_overridden'] == null ? undefined : json['is_runout_overridden'],
        'employee_notes': json['employee_notes'] == null ? undefined : json['employee_notes'],
        'lmn_ids': json['lmn_ids'] == null ? undefined : json['lmn_ids'],
    };
}

export function ICreateClaimAggregatorDtoToJSON(json: any): ICreateClaimAggregatorDto {
    return ICreateClaimAggregatorDtoToJSONTyped(json, false);
}

export function ICreateClaimAggregatorDtoToJSONTyped(value?: ICreateClaimAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requested_amount': value['requested_amount'],
        'pay_to_type': value['pay_to_type'],
        'payment_type': value['payment_type'],
        'service_id': value['service_id'],
        'provider_id': value['provider_id'],
        'organization_id': value['organization_id'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
        'service_for': IClaimActorDtoToJSON(value['service_for']),
        'assignee': IClaimActorDtoToJSON(value['assignee']),
        'source': value['source'],
        'employee_provider_acc': value['employee_provider_acc'],
        'patient_provider_acc': value['patient_provider_acc'],
        'provider_invoice': value['provider_invoice'],
        'organization_path': value['organization_path'],
        'employee_id': value['employee_id'],
        'document_id': value['document_id'],
        'ocr_receipt_id': value['ocr_receipt_id'],
        'claim_status_type': value['claim_status_type'],
        'payment_method_id': value['payment_method_id'],
        'account_orders': value['account_orders'] == null ? undefined : ((value['account_orders'] as Array<any>).map(IClaimAccountOrderDtoToJSON)),
        'external_identifier': value['external_identifier'],
        'receipt_id': value['receipt_id'],
        'is_runout_overridden': value['is_runout_overridden'],
        'employee_notes': value['employee_notes'],
        'lmn_ids': value['lmn_ids'],
    };
}

